import ApplicationStateGeriMed from "@GeriMed/Store/GeriMedState";
import Zone from "@insite/client-framework/Components/Zone";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
        
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import {connect } from "react-redux";

const mapStateToProps = (state: ApplicationStateGeriMed) => {
    return {
        session: state.context.session,
        signInPageUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    };
};


type Props = PageProps & ReturnType<typeof mapStateToProps> & HasHistory;

const PurchaseHistoryPage = ({ id, 
     session,
     signInPageUrl,
     history }: Props) => {

    if(!session.isAuthenticated && signInPageUrl)
    {
         history.push(signInPageUrl);
    }
    return (
        <Page data-test-selector="purchaseHistoryPage">
            <>
                <Zone contentId={id} zoneName="Content" />
                <Modals />
            </>
        </Page>
    );
};


const pageModule: PageModule = {
    component: connect(mapStateToProps)(withHistory(PurchaseHistoryPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
